import l from 'assets/img/l.gif'

const ua = window.navigator.userAgent.toLowerCase()
export default {
  methods: {
    updateTitle (title, img = l) {
      this.$doc = document
      if (title === undefined || this.$doc.title === title) {
        return
      }
      this.$doc.title = title
      if (/(iphone|ipad|ipod|ios)/i.test(ua)) {
        const iframe = document.createElement('iframe')
        iframe.style.display = 'none'
        iframe.setAttribute('src', img || '/favicon.ico')
        const iframeCallback = () => {
          setTimeout(() => {
            iframe.removeEventListener('load', iframeCallback)
            document.body.removeChild(iframe)
          }, 0)
        }
        iframe.addEventListener('load', iframeCallback)
        document.body.appendChild(iframe)
      }
    }
  }
}
